import { render, staticRenderFns } from "./SnapshotItem.vue?vue&type=template&id=50a02434&scoped=true&"
import script from "./SnapshotItem.vue?vue&type=script&lang=js&"
export * from "./SnapshotItem.vue?vue&type=script&lang=js&"
import style0 from "./SnapshotItem.vue?vue&type=style&index=0&id=50a02434&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a02434",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VFlex,VIcon,VLayout,VList,VListItem,VListItemTitle,VMenu})
